<template>
  <div class="ui-loading-state" role="status" aria-live="polite">
    <span class="ui-loading-spinner" aria-hidden="true"></span>
    <span>Loading…</span>
  </div>
</template>

<script>
export default { name: "LoadingDiv" };
</script>

<style scoped>
.ui-loading-state {
  align-items: center;
  color: var(--ui-muted-foreground);
  display: flex;
  flex-direction: column;
  font-size: 0.82rem;
  gap: 0.75rem;
  justify-content: center;
  min-height: 12rem;
  padding: 2rem;
}
.ui-loading-spinner {
  animation: ui-loading-spin 750ms linear infinite;
  border: 3px solid var(--ui-border);
  border-radius: 50%;
  border-top-color: var(--ui-primary);
  height: 2.5rem;
  width: 2.5rem;
}
@keyframes ui-loading-spin { to { transform: rotate(360deg); } }
</style>
